export default __webpack_public_path__ + "static/media/GR00060-plan_box.7fced8f2.svg";